module.exports = __webpack_public_path__ + "img/readon.b524c635.png";